import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchTerm: "",
};

const filterSlice = createSlice({
  name: "filterBySearch",
  initialState,
  reducers: {
    changeSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
  },
});

export const { changeSearchTerm } = filterSlice.actions;
export default filterSlice.reducer;
